module.exports = __webpack_public_path__ + "static/media/ic_access_time_48px.520a817a.svg";